"use strict";
/* eslint-disable camelcase */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const string_hash_1 = __importDefault(require("string-hash"));
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const prop_types_1 = __importDefault(require("prop-types"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const styled_components_1 = __importDefault(require("styled-components"));
const EmbedWrapper = styled_components_1.default.div `
    &.html-video-embed {
        height: 100%;
        width: 100%;
    }
`;
class HtmlVideoEmbed extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.hashId = '';
        this.state = {
            content: []
        };
        this.checkState = props => {
            const { content } = props;
            if (content) {
                if (!(0, lodash_isequal_1.default)(content, this.state.content)) {
                    this.setState({
                        content
                    });
                }
            }
        };
        this.setHash = () => {
            if (!this.hashId && this.props) {
                if (this.props.contentId) {
                    this.hashId = this.props.contentId;
                }
                else if (this.props.content && this.props.content[0]) {
                    const string = this.props.content[0] || '';
                    this.hashId = (0, string_hash_1.default)(string);
                }
                else {
                    console.warn('HtmlVideoEmbed content id and content array is empty');
                }
            }
        };
        this.onClickHtmlVideo = event => {
            event.preventDefault();
            const media = window_or_global_1.default.document.getElementById(`bgVideoHtml5-${this.hashId}`);
            this.html5PlayPause(media);
        };
        this.html5PlayPause = media => {
            if (media) {
                if (media.paused) {
                    media.play();
                }
                else {
                    media.pause();
                    media.currentTime = 0;
                }
                this.setState({
                    hidePlayPause: !media.paused
                });
            }
        };
    }
    UNSAFE_componentWillMount() {
        this.setHash();
        this.checkState(this.props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.play !== nextProps.play ||
            this.props.forcePause !== nextProps.forcePause ||
            (!nextProps.forcePause && nextProps.play)) {
            //need to play/pause
            if (this.hashId) {
                const media = window_or_global_1.default.document.getElementById(`bgVideoHtml5-${this.hashId}`);
                if (media) {
                    if (nextProps.forcePause) {
                        media.pause();
                        media.currentTime = 0;
                        this.setState({
                            hidePlayPause: false
                        });
                    }
                    else if (nextProps.play && media.paused) {
                        try {
                            const play = media.play();
                            if (play && play.then) {
                                play.then(() => {
                                    //console.debug('play success');
                                }, ex => {
                                    console.warn('HtmlVideoEmbed play promise failed: %s', ex.message);
                                });
                            }
                        }
                        catch (e) {
                            console.warn('HtmlVideoEmbed play() failed');
                        }
                    }
                    else if (!nextProps.play && !media.paused) {
                        try {
                            const pause = media.pause();
                            if (pause && pause.then) {
                                pause.then(() => {
                                    //console.debug('pause success');
                                }, () => {
                                    console.warn('HtmlVideoEmbed pause promise failed');
                                });
                            }
                        }
                        catch (e) {
                            console.warn('HtmlVideoEmbed pause() failed');
                        }
                    }
                }
            }
        }
        if (nextProps.height !== this.props.height || nextProps.width !== this.props.width) {
            if (this.hashId) {
                const media = window_or_global_1.default.document.getElementById(`bgVideoHtml5-${this.hashId}`);
                if (media) {
                    media.setAttribute('width', nextProps.width);
                    media.setAttribute('height', nextProps.height);
                }
            }
        }
        this.checkState(nextProps);
    }
    /**
     * Purposely avoid rerendering when height, width, and play props change
     */
    shouldComponentUpdate(nextProps, nextState) {
        if (!(0, lodash_isequal_1.default)(nextState, this.state)) {
            return true;
        }
        const p = this.props;
        if (nextProps.contentId !== p.contentId ||
            nextProps.forcePause !== p.forcePause ||
            nextProps.mute !== p.mute) {
            return true;
        }
        else if (!(0, lodash_isequal_1.default)(nextProps.content, this.state.content)) {
            return true;
        }
        return false;
    }
    render() {
        const sources = [];
        let sourceKey = 0;
        for (const reference of this.props.content) {
            const key = `source-key-${sourceKey++}`;
            sources.push(react_1.default.createElement("source", { key: key, src: reference }));
        }
        return (react_1.default.createElement(EmbedWrapper, { className: "html-video-embed" },
            react_1.default.createElement("video", { loop: true, preload: this.props.play ? 'auto' : 'metadata', muted: this.props.mute, playsInline: this.props.playsInline, autoPlay: this.props.play, id: `bgVideoHtml5-${this.hashId}`, className: "bg-video-html5 html-video", ref: this.hashId, "data-contentid": this.hashId, controls: this.props.controls || false, onClick: this.props.onClick || this.onClickHtmlVideo },
                sources,
                "Your browser does not support HTML5 video.")));
    }
}
exports.default = HtmlVideoEmbed;
HtmlVideoEmbed.propTypes = {
    contentId: prop_types_1.default.string,
    content: prop_types_1.default.array,
    play: prop_types_1.default.bool,
    forcePause: prop_types_1.default.bool,
    height: prop_types_1.default.number,
    width: prop_types_1.default.number,
    onClick: prop_types_1.default.func,
    playsInline: prop_types_1.default.bool,
    mute: prop_types_1.default.bool,
    controls: prop_types_1.default.bool
};
//# sourceMappingURL=HtmlVideoEmbed.js.map